
// コメントの高さが不揃いなので最大値にする
// if( $('body').hasClass('isMobile') ){
// 	var $comment = $('.js-comment-height p');
// 	var max = 0;

// 	$comment.each( function(){
// 		max = Math.max( $(this).height(), max );
// 	});
// 	$('.js-comment-height').css({ height: max + 140 });
// }

// スマホ対策で相関図を縮小
if( $.isMobile ){
	var $sokanzu = $('.js-chara-sokanzu');
	var ORG_W = 880;
	// var ORG_H = 673;
	var box_w = $sokanzu.width();
	var par = box_w / ORG_W;

	var style = $sokanzu.get(0).style;
	var caracolTransform = require('../caracol2/effect/transform_css.js');

	// リサイズして、実際の高さも変更する
	caracolTransform.set_transform( style, 'scale('+par+')');
	// $sokanzu.css({height: ORG_H * par });

}


$('.js-slider-custom-ctrl').bxSlider({
    auto: false,
    infiniteLoop: true,
    touchEnabled: false,
    // prevSelector: '.js-bx_prev',
    // nextSelector: '.js-bx_next',
    prevText: '<i class="icon-syg-arrowbold_left"></i>',
    nextText: '<i class="icon-syg-arrowbold_right"></i>',
    pagerCustom: '.js-slider-custom-ctrl-pager'
});


//////////////////
// WEBPACK FOOTER
// ./js/page/chara.js
// module id = 21
// module chunks = 0